"use strict";
{
    const globalColorSwatches = document.getElementById('colorSwatchesData') ? JSON.parse(document.getElementById('colorSwatchesData').innerText) : null;
    const storedProductSkusInSession = JSON.parse(sessionStorage.getItem("productSkus"));

    const uid = () => {
        return (Date.now().toString(36) + Math.random().toString(36).substring(2));
    };


    class ColorSwatches {
        constructor({ globalColorSwatches, globalLinkedProducts, elem }) {

            this.dom = {
                swatches: elem
            }
            this.options = {}

            this.options = this.getSkuAndColor();
            // this.options.uid = uid();
            this.options.productId = elem.dataset.swatchesProductId ? elem.dataset.swatchesProductId : null;
            this.options.type = elem.dataset.swatchesType ? elem.dataset.swatchesType : null
            this.options.currentColorObj = {};
            this.options.parantTarget = '.ProductItem';

            /* If keep is true - keep the swatch selected */
            this.options.keep = false;
            this.options.isProductCard = false;

            switch (this.options.type) {
                case 'product-card':
                    this.options.swatchLimit = 8;
                    this.options.isProductCard = true;
                    break;

                default:
                    this.options.swatchLimit = 0;
                    break;
            }

            this.colors = globalColorSwatches;

            this.linkedProducts = this.getLinkedProducts({ jsonProductData: globalLinkedProducts });

            this.dom.swatches.removeAttribute('data-swatches-template');

            if (this.linkedProducts === undefined || this.linkedProducts.length <= 1) return this.dom.swatches.remove();

            this.init()
        }


        init() {
            const fragment = new DocumentFragment();
            const itemElement = this.dom.swatches.querySelector('.js-color-Swatches__item');
            const itemListElement = this.dom.swatches.querySelector('.js-color-Swatches__list');


            this.options.currentColorObj.values = this.linkedProducts.find(x => x.productId == Number(this.options.productId));
            this.options.currentColorObj.text = this.options.currentColorObj.values.colorName
            this.dom.itemListElement = itemListElement;
            this.options.currentColorObj.element = this.dom.swatches.querySelector('[data-color-swatches-current-color]')
            this.options.currentColorObj.element.innerText = this.options.currentColorObj.text;

            const availableProducts = this.linkedProducts.filter(x => x.available);

            if (availableProducts.length > 1) {

                availableProducts.slice(-(Number(this.options.swatchLimit))).forEach((item) => {

                    /**Cloning node and creating template for swatches to manipulate */
                    const template = itemElement.cloneNode(true)

                    this.swatch_setup({ item: item, template: template });

                    /** Add swatch to list */
                    fragment.appendChild(template)
                })

                /**
                 * Adding a plus sign, if the amount of variants are more than the limit
                 */
                if (this.options.swatchLimit !== 0 && this.linkedProducts.length > this.options.swatchLimit) {

                    const plusIconContainer = itemElement.cloneNode(true);
                    const plusIcon = document.createElement('div');

                    plusIconContainer.innerHTML = '';
                    plusIcon.innerText = `+ ${ this.linkedProducts.length - this.options.swatchLimit }`
                    plusIconContainer.classList.add('plus-icon__container');
                    plusIconContainer.appendChild(plusIcon);

                    fragment.appendChild(plusIconContainer);
                }

                /**Removing placeholders and adding corrct swatches */
                itemListElement.innerHTML = '';
                itemListElement.appendChild(fragment)
            } else {
                itemListElement.innerHTML = '';
            }
        }

        swatch_setup({ item, template }) {
            this.swatch_changeColorTitle({ item, template });
            this.swatch_addColorOrImage({ item, template });

            if (this.options.isProductCard) {
                this.swatch_changeProductCardImage({ item, template })
            }

        }

        swatch_addColorOrImage({ item, template }) {
            let globalSwatchValue = null;

            if (item.colorName) {
                template.querySelector('.js-color-swatch__url').setAttribute('title', item.colorName);
                template.querySelector('.js-color-Swatches__swatch').setAttribute('alt', item.colorName);
            }

            /** Get global swatch value from theme swatch colors */
            if (globalColorSwatches[item.colorName.toLowerCase()] != undefined) {
                globalSwatchValue = globalColorSwatches[item.colorName.toLowerCase()];
            }

            /**Hex code or image */
            if (globalSwatchValue && globalSwatchValue.charAt(0) === '#') {
                template.querySelector('.js-color-Swatches__swatch').style.backgroundColor = globalSwatchValue;

                const ratio = calculateColorRatio({ color1: globalSwatchValue, color2: '#fefefe' });
                template.querySelector('.js-color-Swatches__swatch').setAttribute('data-wcag-pass', (ratio < 1 / 1.2));
                template.querySelector('.js-color-Swatches__swatch img').remove();
            }
            else {
                let itemImage = globalSwatchValue ? globalSwatchValue : item.image;

                if (itemImage) {



                    /***
                     * Include this in theme {{ 'option_selection.js' | shopify_asset_url | script_tag }}
                     */

                    console.log(itemImage);

                    if (itemImage.includes('_{width}x')) {
                        itemImage = itemImage.replace('_{width}x','');
                    }

                    const imageUrl = itemImage + "&width=48&height=48&crop=center"

                    template.querySelector('.js-color-Swatches__swatch img').setAttribute('src', imageUrl);

                    /***
                     * Preloads image, so it is displayed faster
                     */
                    (new Image()).src = imageUrl;
                }
            }
        }

        swatch_changeColorTitle({ item, template }) {

            /**
             * Set default selected swatch
             */
            if (this.options.currentColorObj.text === item.colorName) {
                template.classList.add('is-selected')
            }

            /**
             * Set url for the linked product
             */
            template.querySelector('.js-color-swatch__url').setAttribute('href', item.url);

            /**
             * Change color text on hover
             */
            template.addEventListener('mouseenter', () => {
                this.options.currentColorObj.element.innerText = item.colorName;

                /**
                 * if keep is true - keep the swatch selected
                 */
                if (this.options.keep === true) {

                    this.dom.itemListElement.querySelectorAll('.js-color-Swatches__item').forEach(elem => {
                        elem.classList.remove('is-selected')
                    });

                    template.classList.add('is-selected')
                } else {
                    //If keep = false, then set color title = original color
                    template.addEventListener('mouseleave', () => {
                        this.options.currentColorObj.element.innerText = this.options.currentColorObj.text;
                    })
                }
            })
        }

        swatch_changeProductCardImage({ item, template }) {


            const productCollectionCardObj = { dom: {} };
            productCollectionCardObj.dom.main = this.dom.swatches.closest(this.options.parantTarget);
            productCollectionCardObj.dom.title = productCollectionCardObj.dom.main.querySelector('.ProductItem__Title a');
            productCollectionCardObj.dom.imageContainer = productCollectionCardObj.dom.main.querySelector('.ProductItem__ImageWrapper .AspectRatio');


            if (!productCollectionCardObj.dom.main) return this.dom.swatches.remove();


            if (productCollectionCardObj && this.options.currentColorObj.text !== item.colorName) {

                const imageElem = document.createElement('img');

                imageElem.setAttribute('data-src', item.image);
                imageElem.setAttribute('data-widths', item.imageSupportedSizes);
                imageElem.setAttribute('data-sizes', 'auto');
                imageElem.classList.add('swatch-image', 'Image--lazyLoad');
                imageElem.style.display = 'none';

                imageElem.draggable = false;

                productCollectionCardObj.dom.imageContainer.appendChild(imageElem);

                template.addEventListener('mouseenter', () => {

                    imageElem.style.display = 'block';

                    const selectedSwatchImages = productCollectionCardObj.dom.imageContainer.querySelectorAll('.swatch-image.is-selected')

                    selectedSwatchImages.forEach(selectedSwatchImage => {
                        selectedSwatchImage.remove('is-selected');
                    });

                    imageElem.classList.add('is-selected');
                })

                if (this.options.keep !== true) {
                    template.addEventListener('mouseleave', () => {
                        imageElem.classList.remove('is-selected');

                    })
                }
            }
            else if (productCollectionCardObj && this.options.colorName === item.color) {
                template.addEventListener('mouseenter', () => {
                    productCollectionCardObj.dom.swatchImage.style.display = 'none'
                })
            }
        }

        getSkuAndColor() {
            const productSku = this.dom.swatches.dataset.swatchesProductSku;

            /** Getting the parts of the SKU that is needed */
            const productSkuBase = productSku.slice(0, 5);
            const productVariant = productSku.slice(5, 4);

            /** first item in the array is the sku */
            /** secound item in the array is the colour name */

            /**
             * Gives => 
             * this.options.sku
             * this.optins.color
             */

            return { "sku": productSkuBase, "color": productVariant }
        }

        getLinkedProducts({ jsonProductData }) {
            if (jsonProductData) {
                return jsonProductData[this.options.sku];
            }
            else {
                console.warn('no jsonProductData');
                return null;
            }
        }
    }

    class ColorSwatchesData {
        constructor() {
            this.options = {}
            this.data = {}
            this.init();
        }

        async init() {
            try {
                await this.getUrlFetchLimit();
                await this.getRequestUrls();
                await this.getProducts();
                await this.saveToSesseion();

                document.dispatchEvent(new CustomEvent('ColorSwatchesData:saved'));

            }
            catch (e) {
                console.error(e);
            }

            initSwatches({ globalLinkedProducts: this.data });
            // reInitSwatchesAfterEvent({ globalLinkedProducts: this.data });
        }

        async getUrlFetchLimit() {
            return fetch('/collections/all?view=swatch-data-limit')
                .then(response => {
                    const limit = response.json()
                    this.options.urlLimit = limit;
                }).catch(e => {
                    console.error(e);
                });
        }

        async getRequestUrls() {
            return new Promise((resolve) => {
                const requestUrls = []
                /**Get all available urls */
                if (this.options.urlLimit > 0) {
                    for (let i = 1; i < (parseInt(Object.values(this.options.urlLimit)) + 1); i++) {
                        const urlFetch = fetch(`/collections/all?view=swatch-data&page=${ i }`).then((response) => response.json());
                        requestUrls.push(urlFetch)
                    }
                }
                else {
                    const urlFetch = fetch(`/collections/all?view=swatch-data&page=${ 1 }`).then((response) => response.json());
                    requestUrls.push(urlFetch)
                }
                this.options.requestUrls = requestUrls;
                resolve()
            })
        }

        async getProducts() {
            const _this = this;
            return Promise.all(this.options.requestUrls).then((data) => {
                // Log the data to the console
                // You would do something with both sets of data here
                const merged = [].concat.apply([], data);
                /**Group the products so they are easier to find */
                const groupedProducts = groupBy(merged, 'sku');

                _this.data = groupedProducts;
            }).catch((e) => {
                // if there's an error, log it
                console.error(e);
            });
        }

        async saveToSesseion() {
            const mySession = window.sessionStorage;
            mySession.setItem("productSkus", JSON.stringify(this.data));
        }
    }


    const initSwatches = () => {

        if (storedProductSkusInSession && JSON.stringify(storedProductSkusInSession) !== '{}') {

            const swatches = document.querySelectorAll('[data-swatches-template]');
            swatches.forEach(swatch => {
                void new ColorSwatches({ globalColorSwatches: globalColorSwatches, globalLinkedProducts: storedProductSkusInSession, elem: swatch });
            });
        }
    }



    /**
     * Checking if storedProductSkusInSession exist, and is not an empty object
     */


    if (storedProductSkusInSession && JSON.stringify(storedProductSkusInSession) !== '{}') {
        //if swatches data init swatches
        initSwatches();
        // reInitSwatchesAfterEvent({ globalLinkedProducts: storedProductSkusInSession });
    }
    else {
        //Get swatches data from custom endpoint
        void new ColorSwatchesData();
    }


    document.addEventListener('filter:reloaded', () => {
        initSwatches();
    });

    document.addEventListener('helloRetail:searched', () => {
        initSwatches();
    });

    document.addEventListener('Carousel:Build', () => {
        initSwatches();
    });


    /****
     * 
     * Helpers
     * 
     */



    // function from https://stackoverflow.com/a/5624139/3695983
    function hexToRgb(hex) {
        var shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
        hex = hex.replace(shorthandRegex, function(m, r, g, b) {
            return r + r + g + g + b + b;
        });

        var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
        return result ? {
            r: parseInt(result[1], 16),
            g: parseInt(result[2], 16),
            b: parseInt(result[3], 16)
        } : null;
    }

    // function from https://stackoverflow.com/a/9733420/3695983                     
    function luminance(r, g, b) {
        var a = [r, g, b].map(function(v) {
            v /= 255;
            return v <= 0.03928
                ? v / 12.92
                : Math.pow((v + 0.055) / 1.055, 2.4);
        });
        return a[0] * 0.2126 + a[1] * 0.7152 + a[2] * 0.0722;
    }

    //https://dev.to/alvaromontoro/building-your-own-color-contrast-checker-4j7o
    function calculateColorRatio({ color1, color2 }) {

        // read the colors and transform them into rgb format
        const color1rgb = hexToRgb(color1);
        const color2rgb = hexToRgb(color2);

        // calculate the relative luminance
        const color1luminance = luminance(color1rgb.r, color1rgb.g, color1rgb.b);
        const color2luminance = luminance(color2rgb.r, color2rgb.g, color2rgb.b);

        // calculate the color contrast ratio
        const ratio = color1luminance > color2luminance
            ? ((color2luminance + 0.05) / (color1luminance + 0.05))
            : ((color1luminance + 0.05) / (color2luminance + 0.05));

        return ratio;
    }

    //   document.querySelector("button").addEventListener("click", function() {
    //     const ratio = calculateColorRatio();
    //     // show results depending on WCAG requirements
    //     const result = `
    //   AA-level large text: ${ratio < 1/3 ? 'PASS' : 'FAIL' }<br>
    //   AA-level small text: ${ratio < 1/4.5 ? 'PASS' : 'FAIL' }<br>
    //   AAA-level large text: ${ratio < 1/4.5 ? 'PASS' : 'FAIL' }<br>
    //   AAA-level small text: ${ratio < 1/7 ? 'PASS' : 'FAIL' }
    //   `;
    //     document.querySelector("#result").innerHTML = result;
    //   });







    const groupBy = (data, ...keys) => {
        // Takes an array of objects and the property by which they should be grouped.
        // Produces an object of arrays keyed by the specified property values.
        // 
        // Provide multiple keys if your data is nested:   groupBy(dogs, 'values', 'emoji')
        // 
        // Ex: [{id: 1, group: 'A'}, {id: 2, group: 'B'}, {id: 3, group: 'A'}],   'group'
        //     =>
        //     {A: [{id: 1, group: 'A'}, {id: 3, group: 'A'}], B: [{id: 2, group: 'B'}]}

        // Ex: {values: {color: 'red'}}, ['values', 'color'] => 'red'
        const getGroupFromItem = (item, keys) => {
            return (keys.length > 1)
                ? getGroupFromItem(item[keys[0]], keys.slice(1))
                : item[keys[0]]
        }

        return data.reduce((results, item) => {
            // Get the first instance of the key by which we're grouping
            var group = getGroupFromItem(item, keys);

            // Ensure that there's an array to hold our results for this group
            results[group] = results[group] || [];

            // Add this item to the appropriate group within results
            results[group].push(item);

            // Return the updated results object to be passed into next reduce call
            return results;
        },
            // Initial value of the results object
            {}
        );
    };
}

